export default [
  {
    fieldName: 'OldPassword',
    label: 'Current password',
    type: 'password',
    isRequired: true,
  },
  {
    fieldName: 'Password',
    label: 'New password',
    type: 'password',
    isRequired: true,
  },
  {
    fieldName: 'PasswordAgain',
    label: 'Confirm new password',
    type: 'password',
    equal: 'Password',
    isRequired: true,
  },
];


// WEBPACK FOOTER //
// ./src/formFields/password.tsx